var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-competence-card-page" }, [
    _c(
      "div",
      { staticClass: "o-width-limiter" },
      [
        _c("competence-card-data-provider", {
          attrs: { "competence-card-id": _vm.id },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(dataProvider) {
                return _c("div", {}, [
                  _c(
                    "div",
                    { staticClass: "t-space-between t-margin-bottom-m" },
                    [
                      _vm.$can("manage", "CompetenceCard")
                        ? _c(
                            "button",
                            {
                              staticClass: "c-button c-button--linkstyle",
                              on: {
                                click: function($event) {
                                  return _vm.$router.back()
                                }
                              }
                            },
                            [_vm._v("Tillbaka")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.displayGetPdfButton
                        ? _c(
                            "button",
                            {
                              staticClass: "c-button c-button--primary",
                              attrs: { type: "button" },
                              on: { click: dataProvider.generatePdf }
                            },
                            [_vm._v("Hämta PDF")]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  dataProvider.loading
                    ? _c("div", { staticClass: "c-spinner" })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.path.includes("create-competence-card") &&
                  !dataProvider.loading &&
                  dataProvider.competenceCard &&
                  !dataProvider.competenceCard.id
                    ? _c("div", { staticClass: "t-margin-top-m" }, [
                        _vm._v(
                          "\n\t\t\t\t\tKompetenskort med id " +
                            _vm._s(_vm.id) +
                            " hittades inte\n\t\t\t\t"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  dataProvider.competenceCard.id
                    ? _c(
                        "h1",
                        {
                          staticClass:
                            "t-text-style-alpha t-margin-bottom-s t-margin-top-s"
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(dataProvider.competenceCard.firstName) +
                              " \n\t\t\t\t\t" +
                              _vm._s(dataProvider.competenceCard.surName) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "c-competence-card-container t-margin-bottom-m"
                    },
                    [
                      dataProvider.competenceCard &&
                      !(
                        dataProvider.mode === "view" &&
                        !dataProvider.competenceCard.id
                      )
                        ? _c(
                            "basic-information",
                            _vm._b(
                              {
                                attrs: {
                                  mode: dataProvider.mode,
                                  id: dataProvider.competenceCard.id,
                                  "workplace-options":
                                    dataProvider.workplaceOptions
                                },
                                on: {
                                  create: dataProvider.create,
                                  edit: dataProvider.edit
                                }
                              },
                              "basic-information",
                              dataProvider.competenceCard.basicInformation,
                              false
                            )
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      dataProvider.competenceCard &&
                      dataProvider.competenceCard.id &&
                      dataProvider.competenceRows
                        ? _c("competence-card-competences", {
                            attrs: {
                              rows: dataProvider.competenceRows,
                              competenceCardId: dataProvider.competenceCard.id
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.id !== "0" &&
                      dataProvider.competenceCard &&
                      dataProvider.competenceCard.id &&
                      dataProvider.courseRows
                        ? _c("competence-card-courses", {
                            attrs: {
                              rows: dataProvider.courseRows,
                              competenceCardId: dataProvider.competenceCard.id
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }